import React, { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import utilService from '../services/utilService';

const BowserPopupNavigation = (Component) => (props) => {
    const history = useHistory();
    const unlistenRef = useRef(null); // Store the unlisten function
    const params = new URLSearchParams(history.location.search);
    const popup = params.get('popup');

    useEffect(() => {
        if (props.open) {
            if (!unlistenRef.current) {
                history.push(`?popup=${props.bowsernavkey}`);
                unlistenRef.current = history.listen((location, action) => {
                    if (action === 'POP') {
                        props.onClose();
                        stopListening();
                    }
                });
            }
        } else {
            popup && stopListening();
        }
    }, [props.open]);


    const stopListening = () => {
        if (unlistenRef.current) {
            utilService.removeParamFromUrl('popup', history);
            // @ts-ignore
            unlistenRef.current();
            unlistenRef.current = null;
        }
    };

    return <Component {...props} />;
};

export default BowserPopupNavigation;
